export default __webpack_public_path__ + "static/media/download-app.a6897944.png";